module.exports = __webpack_public_path__ + "img/quayRampMetro.996f485c.svg";